import { render, staticRenderFns } from "./LandingAfiliado.vue?vue&type=template&id=16acaf06"
import script from "./LandingAfiliado.vue?vue&type=script&lang=js"
export * from "./LandingAfiliado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports